var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ui-border-button",class:{
    'ui-border-button--disabled': _vm.disabled,
  }},[(_vm.loadingLeft)?_c('div',{staticClass:"ui-border-button--loading-left"},[_c('simple-loading')],1):_vm._e(),(_vm.hasIcon)?_c('div',{staticClass:"ui-border-button__icon"},[_vm._t("icon")],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }